import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000,
    backgroundColor: ({ backdropColor }: any) => {
      return backdropColor || 'rgba(220,220,220,0.5)';
    },
  },
  loader: {
    color: ({ spinnerColor }: any) => {
      switch (spinnerColor) {
        case 'dark':
          return theme.palette.primary.dark;
        default:
          return theme.palette.primary.main;
      }
    },
  },
  content: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
  messageContainer: {
    maxWidth: 700,
    textAlign: 'center',
    marginTop: 40,
  },
}));

export default function LoadingBackdrop(props) {
  const {
    open,
    message,
    messageColor = 'white',
    backdropColor = '',
    spinnerColor = 'light',
  } = props;
  const classes = useStyles({ backdropColor, spinnerColor });

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <div className={classes.content}>
        <CircularProgress className={classes.loader} size={90} />
        <div className={classes.messageContainer}>
          <h1 style={{ color: messageColor }}>{message}</h1>
        </div>
      </div>
    </Backdrop>
  );
}
